function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.6 20.182h2.7c.497 0 .9-.407.9-.91V9.718L12 4.061 4.8 9.717v9.556c0 .502.403.909.9.909h2.7V12c0-.502.403-.91.9-.91h5.4c.497 0 .9.408.9.91v8.182zm-1.8 0v-7.273h-3.6v7.273h3.6zM3.347 8.555l8.1-6.364a.893.893 0 011.106 0l8.1 6.364a.912.912 0 01.347.718v10C21 20.779 19.791 22 18.3 22H5.7C4.209 22 3 20.779 3 19.273v-10c0-.28.128-.546.347-.718z"
});

var SvgHome = function SvgHome(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/home.189f9bae.svg";
export { SvgHome as ReactComponent };